import { Injectable } from '@angular/core';

@Injectable()
export class SiteStructure {
    DisplaySiteName:string = "";
    SiteName:string = "";
    SiteId:number = 0;
    SiteCode:string = ""; 

    // NOTE:  the API automatically computes the SiteDistance in both miles & meters (no need to convert between)
    SiteDistanceMeters:number = 0;      
    SiteDistanceMiles:number = 0;
    SiteDistanceMilesDisplay:string = ""; 

    // NOTE:  the API automatically computes the GeofenceRadius in both miles & meters (no need to convert between)
    GeofenceRadiusMeters:number = 0;   // 2019-12-31 SAUSD for restrict Actions to this area
    GeofenceRadiusMiles:number = 0;    // 2019-12-31 SAUSD for restrict Actions to this area
    IsDistanceWithinGeoFence:boolean = false;  // 2019-12-31 SAUSD for restrict Actions to this area

    GpsLongitudeDecimal:number = 0;
    GpsLatitudeDecimal:number = 0;

    HealthRiskFlag:boolean = false;
    FloorPlanFlag:boolean = false;
    MultiFloorFlag:boolean = false;
    IndoorFlag:boolean = false; 
    FormattedAddress:string = "";
    DisplayGroup:string = ""; 
    LocationChoiceTypeCode:string = "";
    MobileUsersActiveCount:number = 0; 

    SiteGroupId:number = 0; 
    SiteGroupCode:string = "";
    SiteGroupName:string = "";

            /* OTHERE DATA RETURNED
            public decimal BoundingSouthLatitude { get; set; }
            public decimal BoundingWestLongitude { get; set; }
            public decimal BoundingNorthLatitude { get; set; }
            public decimal BoundingEastLongitude { get; set; }

            public int MultiFloorLo { get; set; }   
            public int MultiFloorHi { get; set; }   
            public int MultiFloorCount { get; set; }

            ExternalSiteId:string = ""      // 2019-12-31 SAUSD for Marquee RecipientGroupId
            */ 
}

@Injectable()
export class PhotoUploadStatus {
    SuccessFlag:boolean = false;
    PhotoIndex:number = 0;
    PhotoNumber:number = 0;
    PhotoTotal:number = 0;
    UploadAttemptCount:number = 0;
    UploadSuccessCount:number = 0;
    UploadErrorCount:number = 0;
    UploadComplete:boolean = false;

    StatusText:string = "";
    MobileMediaId:number = 0;
    AmbitFileName:string = "";
}


@Injectable()
export class NotificationData {
    IsActive:boolean = false;
    IsStartPanic:boolean = false;   // not used -- just FYI
    SurveyBroadcastId:number = 0;
    ActionableBroadcastId:number = 0;
    AmbitMessageId:number = 0;
    NotificationTypeCode:string = "";  // see constants.ts -- SURVEY | MONITOR | CHAT | ACTIONABLE_FORM | ...
    NotificationSourceCode:string = "";  // PUSH, UNSEEN, etc.
    // typically used for the Alert Dialog box (if any is to be used in lieu of a modal window)
    MessageTitle:string = "";  
    MessageSubTitle:string = "";  
    MessageText:string = "";  
}

@Injectable()
export class ConnectivityData {
    IsOnline:boolean = true;  // start with the assumption we are online as this is not being set on the initial page when its the browser app
    IsBrowser:boolean = false;
    NetworkType:string = "";
    NetworkState:string = "";
}
